import { takeEvery, takeLeading } from 'redux-saga/effects';
import {
    PROFILE_CHANGE_PASSWORD_FETCH,
    PROFILE_CHANGE_USER_FETCH,
    PROFILE_USER_FETCH,
} from '../constants';
import { changePasswordSaga } from './changePasswordSaga';
import { changeUserDataSaga } from './changeUserDataSaga';
import { userSaga } from './userSaga';

export function* rootProfileSaga() {
    yield takeEvery(PROFILE_CHANGE_USER_FETCH, changeUserDataSaga);
    yield takeEvery(PROFILE_CHANGE_PASSWORD_FETCH, changePasswordSaga);
    yield takeLeading(PROFILE_USER_FETCH, userSaga);
}
